
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'getAmountByState'
        ]),
        
        getDefaultAmounts() {
            this.selectedAmount = this.loan.amount;

            let amounts = this.getAmountByState(this.user?.state);

            const loanAmount = this.loan.amount;

            if (amounts.hasOwnProperty(loanAmount)) {
                return amounts;
            }

            amounts = Object.fromEntries(
                Object.entries(amounts).sort(([, a], [, b]) => a - b)
            );

            return amounts;
        }
    }
}